import { Fragment, useEffect, useState } from 'react';
import axiosApiInstance from '@/api/shared/axios-instance';
import { REDUCERS } from '@/constants/reducers';
import { EVENTS_ACTIONS, EVENTS_CATEGORIES, EVENTS_LABELS, logEventTracker } from '@/helpers/events-helper';
import URL_FACTORY from '@/helpers/url-helper';
import JugadoresHeaderSection from '../jugadores-v2/information/JugadoresHeaderSection';
import JugadoresConvocatoriaSeleccion from '../jugadores-v2/JugadoresConvocatoriaSeleccion';
import JugadoresMercadoPrice from '../jugadores-v2/mercado/JugadoresMercadoPrice';
import JugadoresMercadoResumen from '../jugadores-v2/mercado/JugadoresMercadoResumen';
import JugadoresMercadoGraphicComponent from '../jugadores-v2/mercado/JugadoresMercadoGraphicComponent';
import JugadoresMercadoTableComponent from '../jugadores-v2/drawers/historico-mercado/JugadoresMercadoTableComponent';
import CustomDrawer from '@/DesignSystem/components/drawer/CustomDrawer';
import PlacementModalComponent from '../ads-components/placements/placementModal';
import { FANTASY } from '@/helpers/biwenger-helper';

const FantasyHistoricModalComponent = ({ fantasyId, playerId, season, mode, dispatch }) => {
    const [open, setOpen] = useState(false);
    const [player, setPlayer] = useState(null);
    const [cache, setCache] = useState([]);

    const handleClose = () => {
        setOpen(false);
        dispatch({ type: REDUCERS.SHOW_FANTASY_HISTORIC, payload: null });
    };

    useEffect(() => {
        if (fantasyId > 0 || playerId > 0) {
            const isCached = cache?.find(
                (x) => (x.fantasyId == fantasyId || x.playerId == playerId) && x.mode == mode
            );

            if (isCached) {
                setOpen(true);
                setPlayer(isCached.data);
                logEventTracker(EVENTS_ACTIONS.FANTASY_HISTORIC, EVENTS_CATEGORIES.OPEN, EVENTS_LABELS.CACHE);
                return;
            }

            const url = URL_FACTORY.GetHistoricFantasy;

            const payload = {
                playerId: playerId,
                fantasyId: fantasyId,
                season: season,
                mode: mode || FANTASY.FANTASY, // Por defecto Fantasy (2)
            };

            dispatch({ type: REDUCERS.SHOW_SPINNER });

            logEventTracker(EVENTS_ACTIONS.FANTASY_HISTORIC, EVENTS_CATEGORIES.OPEN, EVENTS_LABELS.API);

            axiosApiInstance
                .post(url, payload)
                .then((response) => {
                    if (response.data?.information || response.data?.if) {
                        setOpen(true);
                        setPlayer(response?.data);

                        // Add response to cache
                        setCache((prevCache) => [
                            ...prevCache,
                            {
                                fantasyId: response?.data.fantasyPlayer?.information?.id,
                                playerId: response?.data.information?.id,
                                data: response?.data,
                                season: season,
                                mode: mode,
                            },
                        ]);
                    }
                })
                .finally(() => {
                    dispatch({ type: REDUCERS.HIDE_SPINNER });
                });
        } else {
            setOpen(false);
        }
    }, [fantasyId, playerId, season, mode]);

    const renderModal = () => {
        if (!player || !open) {
            return null;
        }
        return (
            <CustomDrawer title="Histórico de Mercado" open={open} onClose={handleClose}>
                <JugadoresHeaderSection player={player} />
                <JugadoresConvocatoriaSeleccion player={player} />
                <JugadoresMercadoPrice player={player} isDrawer={true} />
                <PlacementModalComponent />
                <JugadoresMercadoResumen player={player} isDrawer={true} />
                <JugadoresMercadoTableComponent player={player} />
                <JugadoresMercadoGraphicComponent player={player} />
            </CustomDrawer>
        );
    };

    if (!player) {
        return null;
    }

    return <Fragment>{renderModal()}</Fragment>;
};

export default FantasyHistoricModalComponent;
